import { createSelector } from 'reselect'
import { createIsOnetrustGroupOptedInSelector } from '@calendly/onetrust/redux'

import { isEmbeddedSelector } from 'selectors/embed'
import { requestSelector } from 'root-api'

export const isGdprAppliedSelector = createSelector(
  requestSelector,
  ({ gdpr_applied: applied }) => applied
)

const shouldHideSelector = ({ gdpr }) => gdpr.isHidden

export const shouldHideOnetrustSelector = createSelector(
  shouldHideSelector,
  isEmbeddedSelector,
  (shouldHide, isEmbedded) => Boolean(shouldHide && isEmbedded)
)

export const isCookiesAllowedSelector = (group = null) => createSelector(
  shouldHideOnetrustSelector,
  createIsOnetrustGroupOptedInSelector(group),
  (isOnetrustHidden, isOnetrustGroupOptedIn) => (isOnetrustHidden || isOnetrustGroupOptedIn)
)

export const isLocalStorageAllowedSelector = isCookiesAllowedSelector
